import React from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import styles from 'features/chatAssist/components/chatAssist.module.scss';
import FeedbackSection from '../FeedbackSection/FeedbackSection';

const MessagesContainerWithFeedback = ({ isWaiting = false, handleRegenerateResponse = () => {}, clientId, conversationId, messages, firstQuestionRef, firstResponseRef }) => {

  return messages.map((msg, index) => {
    const isFirstQuestion = index === 0 && msg.role === "user";
    const isFirstResponse = index === 0 && msg.role === "assistant";

    return (
      <div
        key={`${msg.message_id}-${index}`}
        ref={isFirstQuestion ? firstQuestionRef : isFirstResponse ? firstResponseRef : null}
        className={msg.role === "assistant" ? styles.messageIA : styles.messageUser}
      >
        { msg.role === "assistant" ? (
          <div className={styles.containerMarkDown}>
            <Markdown
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw]}
              components={{
                a: ({ node, ...props }) => (
                  <a {...props} target="_blank" rel="noopener noreferrer">
                    {props.children}
                  </a>
                ),
              }}
            >
              {msg.content}
            </Markdown>
          </div>
        ) : (
          msg.content
        )}
        {msg.role === 'assistant' && (
          <FeedbackSection isWaiting={isWaiting} handleRegenerateResponse={handleRegenerateResponse} clientId={clientId} conversationId={conversationId} message={msg} />
        )}
      </div>
    );
  });
};

export default MessagesContainerWithFeedback;
